import { Button, Modal } from '@bp/ui-components';
import { ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';

type DeleteForbiddenModalProps = {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
};

export const DeleteForbiddenModal = ({ open, onClose, children }: DeleteForbiddenModalProps) => {
  const { t } = useTranslation();

  const [showDetails, setShowDetails] = useState<boolean>(false);

  return (
    <Modal
      title={t('common.deleteForbiddenTitle')}
      isOpen={open}
      onRequestClose={onClose}
      width={'s'}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
    >
      <div className='mb-4 mt-4'>{t('common.deleteForbiddenText')}</div>
      <Button hierarchy={'secondary'} onClick={() => setShowDetails(!showDetails)}>
        {t('common.showDetails')}
      </Button>
      {showDetails ? <>{children}</> : null}
    </Modal>
  );
};
